var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#A93AFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H8V4H4V8H2V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2ZM28 2H24V4H28V8H30V4C30 3.46957 29.7893 2.96086 29.4142 2.58579C29.0391 2.21071 28.5304 2 28 2ZM4 28V24H2V28C2 28.5304 2.21071 29.0391 2.58579 29.4142C2.96086 29.7893 3.46957 30 4 30H8V28H4ZM28 24V28H24V30H28C28.5304 30 29.0391 29.7893 29.4142 29.4142C29.7893 29.0391 30 28.5304 30 28V24H28ZM16 16C16 14.4087 15.3679 12.8826 14.2426 11.7574C13.1174 10.6321 11.5913 10 10 10C8.4087 10 6.88258 10.6321 5.75736 11.7574C4.63214 12.8826 4 14.4087 4 16C4 17.5913 4.63214 19.1174 5.75736 20.2426C6.88258 21.3679 8.4087 22 10 22C11.5913 22 13.1174 21.3679 14.2426 20.2426C15.3679 19.1174 16 17.5913 16 16ZM22 12C19.794 12 18 13.794 18 16C18 18.206 19.794 20 22 20C24.206 20 26 18.206 26 16C26 13.794 24.206 12 22 12ZM22 10C23.5913 10 25.1174 10.6321 26.2426 11.7574C27.3679 12.8826 28 14.4087 28 16C28 17.5913 27.3679 19.1174 26.2426 20.2426C25.1174 21.3679 23.5913 22 22 22C20.4087 22 18.8826 21.3679 17.7574 20.2426C16.6321 19.1174 16 17.5913 16 16C16 14.4087 16.6321 12.8826 17.7574 11.7574C18.8826 10.6321 20.4087 10 22 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectible);
export default __webpack_public_path__ + "static/media/collectible.4bb787abfe8accf9ab0172877a867b16.svg";
export { ForwardRef as ReactComponent };